(function () {
  "use strict";

  AddCatalogContentCtrl.$inject = ['$scope', '$rootScope', '$window', 'resolveData', 'mtypes', 'catalogResource', '$location', 'userGridUtils', 'catalogModel', 'accountFeatures', 'authView', 'trainerPrivilege'];
  angular
    .module('trainerWebApp.controllers')
    .controller('AddCatalogContentCtrl', AddCatalogContentCtrl);

  function AddCatalogContentCtrl($scope, $rootScope, $window, resolveData, mtypes, catalogResource, $location,
                                 userGridUtils, catalogModel, accountFeatures, authView, trainerPrivilege) {

    var userRole = trainerPrivilege.roles();

    // enforce catalog feature
    if ((!~accountFeatures.features.indexOf(mtypes.featureEntry.courseCatalog) && !authView.isActiveAdvancedtrial()) || !userRole.canViewCatalogs) {
      $location.path('/TMS/Home');
      return;
    }

    $window.document.title = "Add Content | Mindflash Training Management System";
    $rootScope.page = {name: 'addContentToCatalog', title: "addContentToCatalog"};

    var catalog = {
      id: resolveData.catalog.id,
      itemsToAdd: []
    };
    $scope.gridData = resolveData.availableItems;
    catalogModel.setCatalog(resolveData.catalog);
    resolveData = null;
    $scope.viewModel = {
      name: catalogModel.catalog.name,
      submitEnabled: false,
      selectedText: ''
    };

    function getGridColumns() {
      return [
        {
          id: "thumb",
          name: "",
          field: "thumb",
          width: 100,
          minWidth: 100,
          maxWidth: 100,
          cssClass: "cell-title",
          headerCssClass: "header-column",
          sortable: false,
          formatter: thumbFormatter
        },
        {
          id: "name",
          name: "Name",
          field: "name",
          maxWidth: 200,
          cssClass: "catalog-add-item-name",
          headerCssClass: "header-column-first",
          sortable: true
        },
        {
          id: "type",
          name: "Type",
          field: "type",
          minWidth: 65,
          maxWidth: 65,
          cssClass: "cell-title",
          headerCssClass: "header-column-first",
          sortable: true
        },
        {
          id: "description",
          name: "Description",
          field: "description",
          minWidth: 200,
          cssClass: "slick-cell-wrap",
          headerCssClass: "header-column",
          sortable: false
        }
      ];
    }

    var gridCommands = $scope.gridCommands = {};
    $scope.gridInfo = {
      options: {
        editable: false,
        enableCellNavigation: false,
        asyncEditorLoading: false,
        enableColumnReorder: false,
        forceFitColumns: true,
        forceSyncScrolling: $scope.gridData.length < 500,
        multiColumnSort: true,
        rowHeight: 85,
        selectCheckboxClass: "slick-cell-checkboxsel-custom"
      },
      columns: getGridColumns(),
      onSelectedRowsChanged: onSelectedRowsChanged,
      onClick: onRowClicked,
      includeSelectCheckbox: true,
      checkboxSelectionFormatter: checkboxSelectionFormatter,
      filterFn: filterer,
      data: []
    };

    function onSelectedRowsChanged(args, value) {
      catalog.itemsToAdd = value;
      if (catalog.itemsToAdd.length === 0) {
        $scope.viewModel.selectedText = null;
      } else {
        var available = $scope.gridData.length;
        var selected = catalog.itemsToAdd.length;
        $scope.viewModel.selectedText = pluralize(available, 'item') + ' | ' + pluralize(selected, 'item') + ' selected | ';
      }
      refreshAddContentButtonState();
    }

    function pluralize(num, word) {
      if (num == 1) return num += ' ' + word;
      return num += ' ' + word + 's';
    }

    this.onSelectedRowsChanged = onSelectedRowsChanged;

    function onRowClicked(item, targetClasses) {
      // ignore clicks on the checkbox itself
      if (targetClasses === 'catalog-add-item-cb') return;

      var args = Array.prototype.slice.call(arguments);
      var rowIdx = args.pop().row;

      var selectedRows = gridCommands.getSelectedRows();
      var selectedIdx = selectedRows.indexOf(rowIdx);

      if (selectedIdx > -1)
        selectedRows.splice(selectedIdx, 1);
      else
        selectedRows.push(rowIdx);

      gridCommands.setSelectedRows(selectedRows.concat());
    }

    this.onRowClicked = onRowClicked;

    $scope.clearItems = function () {
      gridCommands.setSelectedRows([]);
    };

    function checkboxSelectionFormatter(row, cell, value, columnDef, item) {
      var selectedRows = gridCommands.getSelectedRows();
      var checked = !!~selectedRows.indexOf(row);
      return checked ? "<input type='checkbox' checked='checked' class='catalog-add-item-cb'>" : "<input type='checkbox' class='catalog-add-item-cb'>";
    }

    function thumbFormatter(row, cell, value, columnDef, item) {
      return '<img class="catalog-item-thumbnail" src="' + item.thumbUrl + '"/>';
    }

    $scope.addItemsToCatalog = function () {
      if (catalog.itemsToAdd.length === 0) return;
      $scope.viewModel.submitEnabled = false;

      var data = {
        catalogId: catalog.id,
        itemIds: catalog.itemsToAdd
      };
      catalogResource.addItems(data, function (result) {
        $scope.viewModel.submitEnabled = true;
        $location.path('TMS/Catalog/' + catalog.id);
      }, function (error) {
        $scope.viewModel.submitEnabled = true;
      });
    };

    function refreshAddContentButtonState() {
      $scope.viewModel.submitEnabled = catalog.itemsToAdd.length > 0;
    }

    $scope.$watch('catalogSearchCriteria', updateFilter);

    function updateFilter() {
      $scope.filterData = {nameCriteria: $scope.catalogSearchCriteria};
    }

    function filterer(itemToFilter, args) {
      if (!args || !args.nameCriteria) return true;
      return userGridUtils.filter.byName(itemToFilter, args.nameCriteria);
    }
  }

})();
